import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  FaLaptopCode,
  FaShoppingCart,
  FaCogs,
  FaEnvelope,
  FaWhatsapp,
  FaBars,
  FaTimes,
  FaStar,
  FaChevronUp,
  FaReact,
  FaLaravel,
  FaWordpress,
  FaNodeJs,
  FaPhp,
  FaDatabase,
  FaCss3Alt,
  FaHtml5,
  FaMicrosoft,
} from "react-icons/fa";
import { SiTailwindcss, SiMysql, SiDotnet } from "react-icons/si";

import "../Pages/style.css"
export default function WebZoneLandingFull() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [lang, setLang] = useState("en"); // 'en' or 'ar'

  const t = {
    en: {
      name: "WebZone",
      heroTitle: "Modern web experiences that grow your business",
      heroDesc:
        "We build fast, responsive, and beautiful websites, e-commerce stores, and custom business systems.",
      cta: "Get a Free Quote",
      services: "Our Services",
      mission: "Mission & Vision",
      contact: "Get in Touch",
      portfolio: "Portfolio",
      pricing: "Pricing Plans",
      testimonials: "Testimonials",
      technologies: "Technologies",
      faqs: "FAQ",
      aboutTitle: "About Us",
      aboutDesc:
        "We are web developer focused on building useful digital products. I design & build websites and web apps with performance and conversions in mind.",
      send: "Send Message",
      placeholderName: "Your Name",
      placeholderEmail: "Your Email",
      placeholderMessage: "Your Message",
    },
    ar: {
      name: "WebZone",
      heroTitle: "تجارب ويب عصرية تنمّي عملك",
      heroDesc:
        "نقوم ببناء مواقع سريعة ومتجاوبة ومتجاوبة وجميلة، ومتاجر إلكترونية وأنظمة أعمال مخصصة.",
      cta: "احصل على عرض مجاني",
      services: "خدماتنا",
      mission: "المهمة والرؤية",
      contact: "تواصل معنا",
      portfolio: "نماذج أعمال (توضيحية)",
      pricing: "باقات الأسعار",
      testimonials: "آراء العملاء",
      technologies: "التقنيات",
      faqs: "الأسئلة الشائعة",
      aboutTitle: "من نحن",
      aboutDesc:
        "نحن مطورين ويب نركز على بناء منتجات رقمية مفيدة. أصمم وأبني مواقع وتطبيقات ويب مع مراعاة الأداء والتحويل.",
      send: "إرسال",
      placeholderName: "اسمك",
      placeholderEmail: "بريدك الإلكتروني",
      placeholderMessage: "رسالتك",
    },
  }[lang];

  const portfolioDemo = [
    {
      title_en: "E-commerce Store",
      title_ar: "متجر إلكتروني",
      img: "/images/ecommerce.jpg",
      desc_en: "Modern store with payment integration and product management.",
      desc_ar: "متجر عصري مع بوابات دفع وإدارة منتجات.",
      link: "https://godablaze.store/",
    },
   {
  title_en: "Travel & Tourism Websites",
  title_ar: "مواقع سياحة وحجز رحلات",
  img: "/images/business.jpg",
  desc_en: "Professional websites and booking systems for travel agencies — helping you manage tours, destinations, and online reservations with ease.",
  desc_ar: "مواقع احترافية وأنظمة حجز لشركات السياحة، تساعدك على إدارة الرحلات والوجهات والحجوزات بسهولة واحترافية.",
  link: "https://yallaegypttours.com/",
},
    {
      title_en: "Landing Page",
      title_ar: "صفحة هبوط",
      img: "/images/web-development.jpg",
      desc_en: "High-conversion marketing landing pages.",
      desc_ar: "صفحات هبوط لتحويل الزوار لعملاء.",
      link: "https://mediumslateblue-aardvark-390220.hostingersite.com",
    },
  ];

  const pricing = [
    {
      name_en: "Basic",
      name_ar: "أساسي",
      price: "From $50",
      includes_en: ["1 page", "Responsive", "Basic SEO"],
      includes_ar: ["صفحة", "متجاوب", "SEO أساسي"],
    },
    {
      name_en: "Business",
      name_ar: "بيزنس",
      price: "From $400",
      includes_en: ["Up to 10 pages", "CMS", "Performance optim."],
      includes_ar: ["حتى 10 صفحات", "نظام إداري", "تحسين الأداء"],
    },
    {
      name_en: "E-commerce",
      name_ar: "متجر إلكتروني",
      price: "From $650",
      includes_en: ["Products & checkout", "Payment integration", "Training"],
      includes_ar: ["منتجات ودفع", "دمج بوابات", "تدريب"],
    },
  ];

  const faqs = [
    {
      q_en: "How long does a project take?",
      a_en: "Usually 1–4 weeks depending on scope.",
      q_ar: "المشروع ياخد قد إيه؟",
      a_ar: "غالباً من أسبوع إلى 4 أسابيع حسب حجم العمل.",
    },
    {
      q_en: "Do you provide support after delivery?",
      a_en: "Yes — maintenance and support plans are available.",
      q_ar: "هل في دعم بعد التسليم؟",
      a_ar: "نعم — توجد باقات دعم وصيانة.",
    },
  ];
const testimonials = [
  {
    client: "Client 1",
    en: "Our online store turned out amazing — smooth checkout, modern design, and perfect mobile experience!",
    ar: "المتجر الإلكتروني طلع رائع جدًا — عملية شراء سلسة وتصميم عصري وتجربة ممتازة على الموبايل!",
  },
  {
    client: "Client 2",
    en: "The travel booking website made managing tours and reservations super easy — clients love the new system!",
    ar: "موقع الحجز السياحي سهّل إدارة الرحلات والحجوزات جدًا — العملاء مبسوطين من النظام الجديد!",
  },
  {
    client: "Client 3",
    en: "The landing page boosted our ad conversions — clean design and great attention to detail.",
    ar: "صفحة الهبوط زودت نتائج الإعلانات بشكل واضح — تصميم بسيط واهتمام رائع بالتفاصيل.",
  },
];

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <div className={`wz-root ${lang === 'ar' ? 'rtl' : 'ltr'}`}>
   

      {/* NAVBAR */}
      <nav className="navbar">
        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <div className="nav-logo" onClick={() => scrollTo("home")}>{t.name}</div>
          <div style={{ display: "flex", gap: 8 }}>
           
          </div>
        </div>

        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          <a onClick={() => scrollTo("home")}>{lang === "en" ? "Home" : "الصفحة الرئيسية"}</a>
          <a onClick={() => scrollTo("services")}>{t.services}</a>
          <a onClick={() => scrollTo("portfolio")}>{t.portfolio}</a>
          <a onClick={() => scrollTo("pricing")}>{t.pricing}</a>
          <a onClick={() => scrollTo("contact")}>{t.contact}</a>
           <button
              onClick={() => setLang((l) => (l === "en" ? "ar" : "en"))}
              style={{ padding: "6px 10px", borderRadius: 8, border: "none", cursor: "pointer", background: "transparent", color: "#cbd5e1" }}
            >
              {lang === "en" ? "AR" : "EN"}
            </button>
        </div>

        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </div>
      </nav>

     {/* HERO */}
<section id="home" className="hero">
  <motion.div
    initial={{ opacity: 0, y: -20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    className="hero-content"
  >
    <h1>{t.heroTitle}</h1>
    <p>{t.heroDesc}</p>

    <div className="hero-buttons">
      <a
        href="#contact"
        className="cta"
        onClick={(e) => {
          e.preventDefault();
          scrollTo("contact");
        }}
      >
        {t.cta}
      </a>
      <button className="hero-secondary" onClick={() => scrollTo("portfolio")}>
        {lang === "en" ? "See demo work" : "شاهد نماذج"}
      </button>
    </div>
  </motion.div>

  <motion.div initial={{ scale: 0.98 }} animate={{ scale: 1 }} transition={{ duration: 0.8 }}>
    <div className="hero-image-wrapper">
      <img
        src="https://images.unsplash.com/photo-1498050108023-c5249f4df085"
        alt="showcase"
        className="hero-image"
      />
    </div>
  </motion.div>
</section>


{/* SERVICES */}
<section id="services" className="services">
  <h2>{t.services}</h2>

  <div className="services-grid">
    {[
      {
        icon: <FaLaptopCode size={36} />,
        title: lang === "en" ? "Web Development" : "تطوير مواقع",
        desc: lang === "en"
          ? "Responsive, fast, SEO-friendly websites."
          : "مواقع متجاوبة وسريعة ومحسّنة لمحركات البحث",
      },
      {
        icon: <FaShoppingCart size={36} />,
        title: lang === "en" ? "E-commerce" : "متاجر إلكترونية",
        desc: lang === "en"
          ? "Secure, scalable online stores."
          : "متاجر إلكترونية آمنة وقابلة للتوسع.",
      },
      {
        icon: <FaCogs size={36} />,
        title: lang === "en" ? "Custom Systems" : "أنظمة مخصصة",
        desc: lang === "en"
          ? "Automation tools and dashboards."
          : "أنظمة ولوحات تحكم لإدارة أعمالك بذكاء.",
      },
      // {
      //   icon: <FaLaptopCode size={36} />,
      //   title: lang === "en" ? "UI/UX Design" : "تصميم واجهات",
      //   desc: lang === "en"
      //     ? "Modern interfaces focused on user experience."
      //     : "تصميمات حديثة تركّز على تجربة المستخدم.",
      // },
      {
        icon: <FaLaptopCode size={36} />,
        title: lang === "en" ? "Maintenance" : "الصيانة",
        desc: lang === "en"
          ? "Ongoing updates and optimizations."
          : "تحديثات وصيانة وتحسينات مستمرة.",
      },
    ].map((s, i) => (
      <motion.div
        key={i}
        whileHover={{ scale: 1.05 }}
        className="service-card"
        onMouseEnter={(e) => {
          e.currentTarget.classList.add("hovered");
        }}
        onMouseLeave={(e) => {
          e.currentTarget.classList.remove("hovered");
        }}
      >
        <div className="service-icon">{s.icon}</div>
        <h4>{s.title}</h4>
        <p>{s.desc}</p>
      </motion.div>
    ))}
  </div>
</section>

      {/* ABOUT + MISSION */}
    {/* ABOUT + MISSION */}
<section id="mission" className="mission">
  <h2>{t.aboutTitle}</h2>

  <div className="mission-grid">
    {/* About Section */}
    <div
      className="mission-about"
      onMouseEnter={(e) => e.currentTarget.classList.add("hovered")}
      onMouseLeave={(e) => e.currentTarget.classList.remove("hovered")}
    >
      <h3>{t.aboutTitle}</h3>
      <p>{t.aboutDesc}</p>
      <div className="mission-buttons">
        <button className="cta" onClick={() => scrollTo("contact")}>
          {t.cta}
        </button>
        {/* <button className="cv-btn">
          {lang === "en" ? "Download CV" : "تحميل السيرة"}
        </button> */}
      </div>
    </div>

    {/* Mission & Vision */}
    <div className="mission-list">
      {[
        {
          title: lang === "en" ? "Mission" : "المهمة",
          desc: lang === "en"
            ? "Empower brands with modern web products that deliver results."
            : "تمكين العلامات التجارية بمنتجات ويب حديثة تحقق نتائج ملموسة.",
        },
        {
          title: lang === "en" ? "Vision" : "الرؤية",
          desc: lang === "en"
            ? "To become a creative hub for digital innovation in the region."
            : "أن نكون مركزًا للإبداع والابتكار الرقمي في المنطقة.",
        },
      ].map((item, i) => (
        <div
          key={i}
          className="mission-card"
          onMouseEnter={(e) => e.currentTarget.classList.add("hovered")}
          onMouseLeave={(e) => e.currentTarget.classList.remove("hovered")}
        >
          <h4>{item.title}</h4>
          <p>{item.desc}</p>
        </div>
      ))}
    </div>
  </div>
</section>


    {/* PORTFOLIO */}
<section id="portfolio" className="portfolio">
  <h2>{t.portfolio}</h2>

  <div className="portfolio-grid">
    {portfolioDemo.map((p, i) => (
      <motion.div
        key={i}
        whileHover={{ scale: 1.03 }}
        className="portfolio-card"
      >
        {/* <img
          src={p.img}
          alt={lang === "en" ? p.title_en : p.title_ar}
          className="portfolio-img"
        /> */}
        <h4>{lang === "en" ? p.title_en : p.title_ar}</h4>
        <p>{lang === "en" ? p.desc_en : p.desc_ar}</p>
        <a href={p.link} className="portfolio-link">
          {lang === "en" ? "View Project" : "عرض المشروع"}
        </a>
      </motion.div>
    ))}
  </div>
{/* 
  <p className="portfolio-note">
    {lang === "en"
      ? "(Demo items — replace with your real projects in /public/images)"
      : "(نماذج توضيحية — استبدل الصور بالمشاريع الحقيقية في /public/images)"}
  </p> */}
</section>

   <section id="pricing" className="pricing">
  <h2>{t.pricing}</h2>

  <div className="pricing-grid">
    {pricing.map((p, i) => (
      <motion.div
        key={i}
        whileHover={{ y: -6 }}
        className="price-card"
      >
        <h3>{lang === "en" ? p.name_en : p.name_ar}</h3>
        <h2 className="price-value">{p.price}</h2>
        <ul>
          {(lang === "en" ? p.includes_en : p.includes_ar).map((it, idx) => (
            <li key={idx}>{it}</li>
          ))}
        </ul>
        <a
          href="#contact"
          className="cta price-cta"
          onClick={(e) => {
            e.preventDefault();
            scrollTo("contact");
          }}
        >
          {lang === "en" ? "Show Project" : "أطلع على المشروع"}
        </a>
      </motion.div>
    ))}
  </div>
</section>

<section id="stats" className="stats">
  <h2>{lang === "en" ? "Highlights" : "الإنجازات"}</h2>

  <div className="stats-grid">
    {[
      { number: "10+", label_en: "Projects Completed", label_ar: "مشروع مكتمل" },
      { number: "8+", label_en: "Happy Clients", label_ar: "عملاء سعداء" },
      { number: "3+", label_en: "Years Experience", label_ar: "سنوات خبرة" },
    ].map((s, i) => (
      <motion.div key={i} whileHover={{ scale: 1.06 }} className="stat-card">
        <h2 className="stat-number">{s.number}</h2>
        <p className="stat-label">{lang === "en" ? s.label_en : s.label_ar}</p>
      </motion.div>
    ))}
  </div>
</section>

<section id="testimonials" className="testimonials">
  <h2>{t.testimonials}</h2>

  <div className="testimonials-grid">
    {[
      {
        client: "Youssef Mohammed",
        en: "Our online store turned out amazing — smooth checkout, modern design, and perfect mobile experience!",
        ar: "المتجر الإلكتروني طلع رائع جدًا — عملية شراء سلسة وتصميم عصري وتجربة ممتازة على الموبايل!",
      },
      {
        client: "Samer",
        en: "The travel booking website made managing tours and reservations super easy — clients love the new system!",
        ar: "موقع الحجز السياحي سهّل إدارة الرحلات والحجوزات جدًا — العملاء مبسوطين من النظام الجديد!",
      },
      {
        client: "Amged",
        en: "The landing page boosted our ad conversions — clean design and great attention to detail.",
        ar: "صفحة الهبوط زودت نتائج الإعلانات بشكل واضح — تصميم بسيط واهتمام رائع بالتفاصيل.",
      },
    ].map((item, i) => (
      <div key={i} className="testimonial-card">
        <div className="testimonial-header">
          <div className="testimonial-avatar"></div>
          <div>
            <strong className="testimonial-client">{item.client}</strong>
            <div className="testimonial-stars">
              <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar />
            </div>
          </div>
        </div>
        <p className="testimonial-text">{lang === "en" ? item.en : item.ar}</p>
      </div>
    ))}
  </div>
</section>



   <section id="technologies" className="tech">
  <h2>{t.technologies}</h2>

  <div className="tech-grid">
    {[
      { name: "React", icon: <FaReact color="#61DBFB" size={40} /> },
      { name: "Laravel", icon: <FaLaravel color="#FF2D20" size={40} /> },
      { name: "WordPress", icon: <FaWordpress color="#21759B" size={40} /> },
      { name: "Node.js", icon: <FaNodeJs color="#68A063" size={40} /> },
      { name: "Tailwind", icon: <SiTailwindcss color="#38BDF8" size={40} /> },
      { name: "MySQL", icon: <SiMysql color="#00758F" size={40} /> },
      { name: "ASP.NET", icon: <SiDotnet color="#512BD4" size={40} /> },
      { name: "PHP", icon: <FaPhp color="#777BB4" size={40} /> },
    ].map((tech, i) => (
      <div key={i} className="tech-card">
        {tech.icon}
        <span>{tech.name}</span>
      </div>
    ))}
  </div>
</section>

<section id="faqs" className="faqs">
  <h2>{t.faqs}</h2>

  <div className="faqs-grid">
    {faqs.map((f, i) => (
      <motion.div
        key={i}
        className="faq-card"
        whileHover={{ scale: 1.02 }}
        transition={{ duration: 0.2 }}
        onClick={(e) => {
          const p = e.currentTarget.querySelector("p");
          const isOpen = p.style.maxHeight && p.style.maxHeight !== "0px";
          p.style.maxHeight = isOpen ? "0px" : p.scrollHeight + "px";
          p.style.opacity = isOpen ? "0" : "1";
        }}
      >
        <strong>{lang === "en" ? f.q_en : f.q_ar}</strong>
        <p>{lang === "en" ? f.a_en : f.a_ar}</p>
      </motion.div>
    ))}
  </div>
</section>


    <section id="contact" className="contact">
  <h2>{t.contact}</h2>

  <motion.form
    action="https://formspree.io/f/mdkwbyzn"
    method="POST"
    className="contact-form"
    whileHover={{ scale: 1.01 }}
  >
    <input name="name" type="text" placeholder={t.placeholderName} required />
    <input name="email" type="email" placeholder={t.placeholderEmail} required />
    <textarea name="message" placeholder={t.placeholderMessage} rows={5} required></textarea>
    <motion.button type="submit" className="cta" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.97 }}>
      {t.send}
    </motion.button>
  </motion.form>

  <div className="social">
    <motion.a href="https://wa.me/201223361511" target="_blank" rel="noreferrer" whileHover={{ scale: 1.2 }}>
      <FaWhatsapp size={22} />
    </motion.a>

    <motion.a href="mailto:antonymilad199@gmail.com" whileHover={{ scale: 1.2 }}>
      <FaEnvelope size={22} />
    </motion.a>
  </div>

  <p className="contact-note">
    {lang === "en"
      ? "W'll reply within 24 hours — let's build something great together!"
      : "سوف نرد خلال 24 ساعة — لنبدأ معًا في بناء شيء رائع!"}
  </p>
</section>


   <footer className="footer">
  © {new Date().getFullYear()} WebZone — Crafted with ❤️. &nbsp;
  <a href="#home" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="back-to-top">
    Back to top
  </a>
</footer>

{/* Floating WhatsApp */}
<a className="floating-whatsapp" href="https://wa.me/201223361511" target="_blank" rel="noreferrer">
  <FaWhatsapp color="white" />
</a>

{/* Small helper button */}
<button className="scroll-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
  <FaChevronUp />
</button>

    </div>
  );
}
